import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    position: 'relative',
    margin: theme.spacing(3),
    width: theme.spacing(50),
  },
  menu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  subMenu: {
    flexGrow: 1,
    position: 'relative',
    padding: '1rem',
    textAlign: 'center',
    margin: theme.spacing(3),
    width: theme.spacing(18),
  },
  subMenuSelect: {
    flexGrow: 1,
    position: 'relative',
    padding: '1rem',
    textAlign: 'center',
    boxShadow: '5px 5px',
    margin: theme.spacing(3),
    width: theme.spacing(18),
  },
  paypalIcon: {
    width: theme.spacing(3),
  },
  fieldofpayment: {
    width: '100%',
  },
}));
